<medrecord-auth-confirmation-info
  [title]="'common_success' | translate"
  [description]="'auth_invitation_accepted_description' | translate"
></medrecord-auth-confirmation-info>
